import { render } from "./FKBreadCrumb.vue?vue&type=template&id=56201c98&ts=true"
import script from "./FKBreadCrumb.vue?vue&type=script&lang=ts"
export * from "./FKBreadCrumb.vue?vue&type=script&lang=ts"

import "./FKBreadCrumb.vue?vue&type=style&index=0&id=56201c98&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Widgets/BreadCrumb/FKBreadCrumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56201c98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56201c98', __exports__)) {
    api.reload('56201c98', __exports__)
  }
  
  module.hot.accept("./FKBreadCrumb.vue?vue&type=template&id=56201c98&ts=true", () => {
    api.rerender('56201c98', render)
  })

}


export default __exports__